import { defineComponent as _defineComponent } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  type: string;
  // TODO: should be turned to v-model
  searchFilter: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    type: { default: '' },
    searchFilter: { default: '' }
  },
  setup(__props: any) {

library.add(faSearch);

/* -- Props -- */



return { __sfc: true, }
}

})